import * as React from 'react'
import {parseCookies} from 'nookies'
import useSWR from 'swr'
import {useParams} from 'react-router-dom'
import {APIURL} from '../../../../config/config'
import Pagination from 'replace-js-pagination'
import {Table} from 'react-bootstrap'
import InfluencerSkeleton from '../Influencer/InfluencerSkeleton'

const SentRequest = () => {
  const params = useParams()
  const {id: campaign_id} = params

  const cookies = parseCookies()
  const token = cookies?.token

  const [total, setTotal] = React.useState<number>(0)
  const [currentPage, setCurrentPage] = React.useState<number>(1)
  const [perPage, setPerpage] = React.useState<number>(0)
  const [lastPage, setLastPage] = React.useState<number>(0)
  const [activePage, setActivePage] = React.useState<number>(1)
  const [nextPage, setNextPage] = React.useState<boolean>(false)
  const [prevPage, setPrevPage] = React.useState<boolean>(false)

  const fetcher = async (url: string) => {
    var myHeaders = new Headers()
    myHeaders.append('Authorization', `Bearer ${token}`)
    var requestOptions: any = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow',
    }

    const response = await fetch(url, requestOptions)
    const result = await response.json()
    if (result.success === true) {
      setActivePage(result?.paginate?.current_page)
      setTotal(result?.paginate?.total)
      setCurrentPage(result?.paginate?.current_page)
      setPerpage(result?.paginate?.per_page)
      setLastPage(result?.paginate?.last_page)
      if (result?.paginate?.next_url === null) {
        setNextPage(false)
      } else {
        setNextPage(true)
      }
      if (result?.paginate?.prev_url === null) {
        setPrevPage(false)
      } else {
        setPrevPage(true)
      }

      //   check if influencer is invited in campaign or not
      const invitedInfluencerByCampaign: any[] = []

      result?.data?.map((item: any) => {
        return item?.campaign_id == campaign_id ? invitedInfluencerByCampaign.push(item) : []
      })

      return invitedInfluencerByCampaign
    }
  }

  const {data: requestList, isLoading} = useSWR(
    `${APIURL}/merchant/request-list?page=${currentPage}`,
    fetcher
  )

  const handlePageChange = (page: number) => {
    if (nextPage) {
      setCurrentPage((pre) => pre + 1)
    }

    if (prevPage) {
      setCurrentPage((pre) => pre - 1)
    }
  }

  return (
    <>
      <div
        className='row g-5 g-xl-10 mb-xl-10'
        style={{
          marginTop: '-60px',
        }}
      >
        <div className='col-xl-12'>
          <div className='card card-xl-stretch'>
            <div className='card-header border-0 bg-success py-5'>
              <h3 className='card-title fw-bolder text-white'>Invited Influencer List</h3>
            </div>
            <div className='card-body p-2'>
              <div className='row mb-4'>
                <div className='col-sm-12'>
                  <Table striped bordered hover responsive>
                    <thead>
                      <tr>
                        <th className='fs-4 text-center'>Profile Photo</th>
                        <th className='fs-4 text-center'>Name</th>
                        <th className='fs-4 text-center'>Email</th>
                        <th className='fs-4 text-center'>Phone</th>
                        <th className='fs-4 text-center'>Address</th>
                        <th className='fs-4 text-center'>Followers</th>
                        <th className='fs-4 text-center'>Skills</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoading && (
                        <>
                          {new Array(10).fill(0).map((_, index) => (
                            <InfluencerSkeleton column={5} key={index} />
                          ))}
                        </>
                      )}

                      {!isLoading && Array.isArray(requestList) && requestList?.length === 0 && (
                        <tr>
                          <td colSpan={8} className='text-center py-8'>
                            No Data Found
                          </td>
                        </tr>
                      )}

                      {!isLoading &&
                        requestList &&
                        requestList.map((item: any, index: number) => (
                          <tr
                            key={`${item?.influencer?.influencer_id}.${index}`}
                            className='align-middle'
                          >
                            <td className='text-center'>
                              <picture className='symbol symbol-45px me-5'>
                                {/* <img
                                  src={item?.influencer?.photo_url}
                                  alt={item?.influencer?.full_name}
                                  style={{width: '80px'}}
                                /> */}
                                <img
                                  src={item?.influencer?.photo_url}
                                  alt={item?.influencer?.full_name}
                                  style={{width: '80px', height: '80px', objectFit: 'cover'}}
                                />
                              </picture>
                            </td>
                            <td className='text-center'>{item?.influencer?.full_name}</td>
                            <td className='text-center'>{item?.influencer?.email}</td>
                            <td className='text-center'>{item?.influencer?.phone}</td>
                            <td className='text-center'>{item?.influencer?.address}</td>
                            <td className='text-center'>
                              {item?.influencer?.social_stats?.map((social: any, index: any) => (
                                <span
                                  key={`${social.social_id}.${index}`}
                                  className='mb-1 d-block'
                                  style={{
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  {social.name}: {social.followers}
                                  {index !== item?.influencer?.social_stats?.length - 1 && ', '}
                                </span>
                              ))}
                            </td>
                            <td className='text-center'>
                              {item?.influencer?.skills?.map((skill: any, index: any) => (
                                <span
                                  key={`${skill.skill_id}.${index}`}
                                  className='badge badge-info mb-1 me-1'
                                >
                                  {skill.skill_name}
                                </span>
                              ))}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </div>
                <div className='col-sm-12'></div>
              </div>
            </div>
            <div className='card-footer p-4 mb-2 bg-secondary'>
              <div className='d-flex flex-stack flex-wrap'>
                <div className='fs-6 fw-bold text-gray-700'>
                  Showing {currentPage} to {perPage} of {total} entries
                </div>

                <div className='pagination'>
                  <Pagination
                    hideFirstLastPages={false}
                    hideNavigation={true}
                    linkClassFirst='next'
                    linkClassPrev='previous'
                    itemClass='page-item'
                    linkClass='page-link'
                    activePage={activePage}
                    itemsCountPerPage={perPage}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SentRequest
